import secureApi from '../../utils/secureApi';

export interface WeeklyReportUpdatePayload {
  _id: string;
  tournament?: string | {
    _id: string;
    name: string;
    startDate: string;
    endDate: string;
  };
  tournamentSeason?: string;
  title?: string;
  desc?: string;
  images?: string[];
  html?: string;
  dateUploaded?: string;
  slug?: string;
  tag?: string;
  publishDate?: string;
  publishTime?: string;
}

export async function updateWeeklyReport(id: string, payload: Omit<WeeklyReportUpdatePayload, '_id'>) {
  const response = await secureApi.post<any>(
    `/api/v2/tournaments/admin/weeklyReports/edit`,
    { ...payload, _id: id }
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response._id) {
    return response; // Already the expected structure
  } else if (response && response.data && response.data._id) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
} 